/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useMemo} from "react";
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import PeopleIcon from '@mui/icons-material/People';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";

import Acl from "./panel/Acl"
import AclRoles from "./panel/AclRoles";
import GroupInfo from "./panel/GroupInfo";
import PersonInfo from "./panel/PersonInfo";
import Admins from "./panel/Admins";
import Query from "./panel/Query";
import Groups from "./panel/Groups";
import People from "./panel/People";
import Mfa from "./panel/Mfa";
import Import from "./panel/Import";


export const useCommonPages = () => useMemo(() => [
    ['ACL',          '/acl',             <Acl/>,          {icon: <AdminPanelSettingsIcon/>}],
    ['ACL Roles',    '/aclroles',        <AclRoles />,    {icon: <DashboardCustomizeOutlinedIcon/>}],
    ['Admins',       '/admins',          <Admins/>,       {icon: <AdminPanelSettingsOutlinedIcon/>}],
    ['Query',        '/query',           <Query/>,        {icon: <QueryStatsOutlinedIcon/>}],
    ['GroupInfo',    '/group/:email',    <GroupInfo/>,    {hide: true}],
    ['PersonInfo',   '/person/:email',   <PersonInfo/>,   {hide: true}],
    ['MFA',          '/mfa',             <Mfa/>,          {hide: true, allusers: true}],
    ['Groups',       '/groups',          <Groups/>,       {icon: <GroupsIcon/>}],
    ['People',       '/people',          <People/>,       {icon: <PeopleIcon/>}],
    ["Import",       "/import",          <Import/>,       {icon: <CloudDownloadOutlinedIcon/>}],
], [])
